export default __webpack_public_path__ + "static/media/process.e74e9da3.png";